import { AuthProvider } from 'react-admin';
import { fetchUtils } from 'react-admin';

const httpClient = fetchUtils.fetchJson;

import apiUrl from '../config';

const authProvider = {
    login: ({ username, password }) => {
        const body = JSON.stringify({ email: username, password: password });

        const request = new Request(apiUrl + '/login', {
            method: 'POST',
            body: body,
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });

        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.message);
                }
                return response.json();
            })
            .then(jsonResponse => {
                console.log(jsonResponse);

                localStorage.setItem('userdata', jsonResponse.data);
                localStorage.setItem('username', jsonResponse.data.email);
                localStorage.setItem('token', jsonResponse.token);

                var avatar = jsonResponse.data.avatar;
                if (avatar != null) {
                    if (avatar.length > 0) {
                        localStorage.setItem('avatar', jsonResponse.data.avatar);
                    }
                }

                document.cookie = "token=" + jsonResponse.token;

                //localStorage.setItem('auth', JSON.stringify(auth));
            })
            .catch(() => {
                throw new Error('Network error')
            });
    },
    logout: () => {
        localStorage.removeItem('username');
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('avatar');
        localStorage.removeItem('userdata');

        document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        
        return Promise.resolve();
    },
    checkAuth: () => {
        const token = localStorage.getItem('token');
        if (token != null) {
            document.cookie = "token=" + token;
            return Promise.resolve();
        } else {
            return Promise.reject();
        }
    },
    checkError:  (error) => {
        console.log("Check error....");

        const status = error.status;
        if (status === 401 || status === 403) {
            
            localStorage.removeItem('username');
            localStorage.removeItem('token');
            localStorage.removeItem('role');
            localStorage.removeItem('avatar');
            localStorage.removeItem('userdata');

            document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            return Promise.reject();
        }
        // other error code (404, 500, etc): no need to log out
        return Promise.resolve();
    },
    getIdentity: () =>
        Promise.resolve(localStorage.getItem('userdata')),
    getPermissions: () => Promise.resolve(''),
};

export default authProvider;